module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-outline', {
    attrs: {
      "title": 'Information du document'
    }
  }, [_c('template', {
    slot: "pageContent"
  }, [(_vm.activateSpinner) ? _c('spinner') : _c('div', [_c('b-row', [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('suppliers.supplier'),
      "inputValue": _vm.document.GroupReference
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('common.status.status_label'),
      "inputValue": _vm.getStatusLabel(_vm.document.Status, _vm.document.Role),
      "statusIcon": _vm.getStatusIcon(_vm.document.Status, '0')
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('businessDocuments.document_type'),
      "inputValue": _vm.document.Type
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('common.date_label'),
      "inputValue": _vm.getDate(_vm.document.LastUpdateDate)
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "form-group"
  }, [_c('a', {
    staticClass: "linkAction",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.seeSupplierDetails(_vm.document.IdSeller)
      }
    }
  }, [_vm._v("\n            Voir le dossier KYB\n          ")])])], 1), _vm._v(" "), (_vm.document.Serialize !== null && Object.keys(_vm.document.Serialize).length !== 0 && this.serializeGet.length !== 0) ? _c('form-accordion', {
    attrs: {
      "title": _vm.$t('businessDocuments.doc_details')
    }
  }, [_c('b-row', [_vm._l((_vm.serializeGet), function(value) {
    return [(value.type === 'object') ? _vm._l((value[0]), function(subvalue, subindex) {
      return _c('b-col', {
        key: subindex,
        staticClass: "form-group",
        attrs: {
          "sm": "6"
        }
      }, [_c('form-read-group-label-input', {
        attrs: {
          "idLabel": _vm.$t('businessDocuments.serialize.' + _vm.document.Type + '.' + subindex.name),
          "inputValue": _vm.document.Serialize[value.name].Value[0][subindex.name],
          "specificErrorIndicator": _vm.document.Serialize[value.name].Valid === '0',
          "warningIndicator": _vm.showWarningIndicator(value.name, _vm.document.Serialize),
          "specificMessage": _vm.getAssociatedMessage(_vm.document.Serialize[value.name].Description)
        }
      })], 1)
    }) : (value.type === 'date') ? _c('b-col', {
      staticClass: "form-group",
      attrs: {
        "sm": "6"
      }
    }, [_c('form-read-group-label-input', {
      attrs: {
        "idLabel": _vm.$t('businessDocuments.serialize.' + _vm.document.Type + '.' + value.name),
        "inputValue": _vm.document.Serialize[value.name].Value,
        "specificErrorIndicator": _vm.document.Serialize[value.name].Valid === '0',
        "warningIndicator": _vm.showWarningIndicator(value.name, _vm.document.Serialize),
        "specificMessage": _vm.getAssociatedMessage(_vm.document.Serialize[value.name].Description)
      }
    })], 1) : (value.type === 'boolean' && value.change === '0') ? _c('b-col', {
      staticClass: "form-group",
      attrs: {
        "sm": "6"
      }
    }, [_c('label', [_vm._v(_vm._s(_vm.$t('businessDocuments.serialize.' + _vm.document.Type + '.' + value.name)))]), _vm._v(" "), (_vm.document.Serialize[value.name].Value === '0') ? _c('div', [_c('i', {
      staticClass: "icon fa fa-check",
      staticStyle: {
        "color": "green",
        "font-size": "30px"
      }
    }), _vm._v("\n                  " + _vm._s(_vm.$t('common.status.valid_control_key')) + "\n              ")]) : _c('div', [_c('i', {
      staticClass: "icon fa fa-ban",
      staticStyle: {
        "color": "red",
        "font-size": "30px"
      }
    }), _vm._v("  \n                "), (_vm.document.Serialize[value.name].Value === '1') ? _c('span', [_vm._v("\n                  " + _vm._s(_vm.$t('errors.invalid_control_key')) + "\n                ")]) : (_vm.document.Serialize[value.name].Value === '2') ? _c('span', [_vm._v("\n                  " + _vm._s(_vm.$t('errors.out_of_date')) + "\n                ")]) : (_vm.document.Serialize[value.name].Value === '3') ? _c('span', [_vm._v("\n                  " + _vm._s(_vm.$t('errors.invalid_control_key_out_of_date')) + "\n                ")]) : _vm._e()])]) : (value.type === 'list') ? _c('b-col', {
      staticClass: "form-group",
      attrs: {
        "sm": "6"
      }
    }, [_c('form-write-group-label-input', {
      attrs: {
        "inputType": "listeSelect",
        "idLabel": _vm.$t('businessDocuments.serialize.' + _vm.document.Type + '.' + value.name),
        "specificErrorIndicator": _vm.document.Serialize[value.name].Valid === '0',
        "warningIndicator": _vm.showWarningIndicator(value.name, _vm.document.Serialize),
        "specificMessage": _vm.getAssociatedMessage(_vm.document.Serialize[value.name].Description),
        "additionalMessage": _vm.document.Serialize[value.name].ValueOCR ? 'OCR : ' + _vm.getOCRValueLabel(value.name, _vm.document.Serialize[value.name].ValueOCR) : ''
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.document.Serialize[value.name].Value),
        expression: "document.Serialize[value.name].Value"
      }],
      staticClass: "form-control",
      attrs: {
        "readonly": ""
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.document.Serialize[value.name], "Value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v(_vm._s(_vm.$t('ocr.slct_' + value.name)))]), _vm._v(" "), _vm._l((_vm.getOCRValues(value.name)), function(listValue) {
      return (_vm.getOCRValueLabel(value.name, listValue)) ? _c('option', {
        key: listValue,
        domProps: {
          "value": listValue
        }
      }, [_vm._v("\n                    " + _vm._s(_vm.getOCRValueLabel(value.name, listValue)) + "\n                  ")]) : _vm._e()
    })], 2)])], 1) : _c('b-col', {
      staticClass: "form-group",
      attrs: {
        "sm": "6"
      }
    }, [_c('form-write-group-label-input', {
      attrs: {
        "idLabel": _vm.$t('businessDocuments.serialize.' + _vm.document.Type + '.' + value.name),
        "specificErrorIndicator": _vm.document.Serialize[value.name].Valid === '0',
        "warningIndicator": _vm.showWarningIndicator(value.name, _vm.document.Serialize),
        "specificMessage": _vm.getAssociatedMessage(_vm.document.Serialize[value.name].Description)
      },
      model: {
        value: (_vm.document.Serialize[value.name].Value),
        callback: function($$v) {
          _vm.$set(_vm.document.Serialize[value.name], "Value", $$v)
        },
        expression: "document.Serialize[value.name].Value"
      }
    }, [_c('template', {
      slot: "additionalMessage"
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.getAdditionalMessage(_vm.document.Serialize[value.name]))
      }
    })])], 2)], 1)]
  })], 2), _vm._v(" "), _c('b-row', {
    staticClass: "justify-content-start"
  }, [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "md": "3"
    }
  }, [_c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    on: {
      "click": function($event) {
        return _vm.controlFields()
      }
    }
  }, [_vm._v("\n              " + _vm._s('Vérifier') + "\n            ")])], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "md": "3"
    }
  }, [_c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_vm._v("\n              " + _vm._s('Annuler') + "\n            ")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "form-group"
  }, [_c('a', {
    staticClass: "linkAction",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.showDocument = !_vm.showDocument
      }
    }
  }, [_vm._v("\n            Cliquer ici pour afficher/cacher le document\n          ")])])], 1), _vm._v(" "), (_vm.showDocument) ? _c('b-row', [_c('b-col', {
    staticClass: "form-group"
  }, [_c('document-viewer', {
    attrs: {
      "src": _vm.document.Data
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-row', {
    staticClass: "justify-content-start"
  }, [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "md": "3"
    }
  }, [_c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    on: {
      "click": function($event) {
        return _vm.downloadDocument(_vm.document.Name, _vm.document.Data)
      }
    }
  }, [_c('i', {
    staticClass: "icon fa fa-download"
  }), _vm._v("\n            " + _vm._s(_vm.$t('common.dwnld')) + "\n          ")])], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "md": "3"
    }
  }, [_c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    on: {
      "click": function($event) {
        return _vm.uploadDocument()
      }
    }
  }, [_c('i', {
    staticClass: "icon fa fa-upload"
  }), _vm._v("\n            " + _vm._s(_vm.$t('common.updt')) + "\n          ")])], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "md": "3"
    }
  }, [_c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    on: {
      "click": function($event) {
        return _vm.updateDecisionLevel2($event, _vm.document, 'ACCP')
      }
    }
  }, [_c('i', {
    staticClass: "icon list-icon icon-accept-doc"
  }), _vm._v("\n            " + _vm._s(_vm.$t('common.accpt')) + "\n          ")])], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "md": "3"
    }
  }, [_c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    on: {
      "click": function($event) {
        return _vm.updateDecisionLevel2($event, _vm.document, 'RFSL')
      }
    }
  }, [_c('i', {
    staticClass: "icon list-icon icon-reject-doc"
  }), _vm._v("\n            " + _vm._s(_vm.$t('common.refus')) + "\n          ")])], 1)], 1), _vm._v(" "), (_vm.document.History != null) ? _c('form-accordion', {
    attrs: {
      "title": _vm.$t('businessDocuments.request_history')
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "form-group"
  }, [_c('table', {
    staticClass: "table table-striped table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('businessDocuments.action_date')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('businessDocuments.doc_status_label')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.document.History), function(value, index) {
    return _c('tr', {
      staticClass: "transactionDetailFontSize"
    }, [_c('td', {
      staticClass: "dateTimehistoryHeight"
    }, [_vm._v("\n                    " + _vm._s(_vm.getDateTime(value.DateChange)) + "\n                  ")]), _vm._v(" "), _c('td', [_c('b-row', [_c('b-col', {
      staticClass: "statusHistoryLabel",
      attrs: {
        "sm": "7"
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.getStatusLabel(value.Status)) + "\n                        "), _c('i', {
      class: 'icon icon-transaction-detail ' + _vm.getStatusIcon(value.Status)
    })]), _vm._v(" "), _c('b-col', {
      attrs: {
        "sm": "5"
      }
    }, [(_vm.showDocumentHistoric(value)) ? _c('f7-button', {
      staticClass: "xmlButtonBackground",
      on: {
        "click": function($event) {
          return _vm.downloadDocument(value.DocumentName, value.DocumentData)
        }
      }
    }, [_vm._v("\n                          " + _vm._s(_vm.$t('common.dwnld')) + "\n                        ")]) : _vm._e()], 1)], 1), _vm._v(" "), (value.Status === 14 && value.DecisionMessage !== '') ? _c('div', {
      staticClass: "item-content"
    }, [_c('div', {
      staticClass: "item-inner",
      staticStyle: {
        "display": "block"
      }
    }, [_c('div', {
      staticClass: "item-title-row",
      staticStyle: {
        "font-style": "italic"
      }
    }, [_vm._v("\n                          " + _vm._s(_vm.$t('common.rfs_cmmnt')) + ":\n                        ")]), _vm._v(" "), _c('div', {
      staticClass: "item-title-row"
    }, [_c('div', {
      staticStyle: {
        "color": "#8e8e93"
      }
    }, [_vm._v("\n                            " + _vm._s(value.DecisionMessage) + "\n                          ")])])])]) : _vm._e()], 1)])
  }), 0)])])], 1)], 1) : _vm._e()], 1)], 1)], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-00872864", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00872864","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/requests/detailPages/supplierDetailPages/DocumentToValidateDetailPage.vue
// module id = 2262
// module chunks = 2